export default function Mission() {
  return (
    <section id="missao" className="py-24 bg-gradient-to-br from-gray-50 to-amber-50/30">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-sm font-semibold mb-6 uppercase tracking-wider">
            Nosso Propósito
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Missão, Visão e Trabalho
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-16">
          {/* Mission Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl mb-6">
              <i className="ri-compass-3-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Missão</h3>
            <p className="text-gray-600 leading-relaxed">
              Construir com excelência e transparência, entregando empreendimentos que gerem valor e orgulho para nossos clientes, parceiros e comunidade. A Gleimatus tem como propósito transformar sonhos em realidade, com responsabilidade social e sustentabilidade econômica.
            </p>
          </div>

          {/* Vision Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl mb-6">
              <i className="ri-eye-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Visão</h3>
            <p className="text-gray-600 leading-relaxed">
              Ser reconhecida como uma das principais incorporadoras do interior de Minas Gerais, referência em qualidade construtiva, credibilidade e inovação, ampliando sua presença regional e fortalecendo parcerias sólidas no mercado imobiliário.
            </p>
          </div>

          {/* Work Card */}
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100">
            <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-amber-500 to-amber-600 rounded-2xl mb-6">
              <i className="ri-hammer-line text-white text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Nosso Trabalho</h3>
            <p className="text-gray-600 leading-relaxed">
              A Gleimatus acredita que construir é mais do que erguer paredes, é criar espaços de vida, conforto e investimento. Cada empreendimento é planejado com atenção aos detalhes, desde a escolha do terreno até o acabamento final.
            </p>
          </div>
        </div>

        {/* Project Stats */}
        <div className="bg-gradient-to-r from-amber-600 to-amber-500 rounded-2xl p-12 text-white">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold mb-4">Empreendimento Atual em Destaque</h3>
            <p className="text-amber-100 text-lg">
              Gestão eficiente com cronograma técnico de 12 meses
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">R$ 1.157.485</div>
              <div className="text-amber-100 uppercase tracking-wider text-sm">VGV Total</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">R$ 353 mil</div>
              <div className="text-amber-100 uppercase tracking-wider text-sm">Já Investidos</div>
            </div>
            <div className="text-center">
              <div className="text-5xl font-bold mb-2">R$ 450 mil</div>
              <div className="text-amber-100 uppercase tracking-wider text-sm">Captação Planejada</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}